// extracted by mini-css-extract-plugin
export default {"main":"secondary-top-bar_main__DwD+k"};